import type { PrivateLessonSlot } from '~entities/private-lessons/api/private-lessons';
import { Button } from '~shared/shadcn/ui/button';

import { formatPrivateLessonSlotTime } from './private-lesson-booking-helpers';

type PrivateLessonSlotPickerProps = {
  slots: PrivateLessonSlot[];
  selectedSlot: PrivateLessonSlot | null;
  onSelect: (slot: PrivateLessonSlot) => void;
  timezone?: string;
  isLoading?: boolean;
};

export const PrivateLessonSlotPicker = ({
  slots,
  selectedSlot,
  onSelect,
  timezone,
  isLoading,
}: PrivateLessonSlotPickerProps) => {
  if (isLoading) {
    return (
      <p className='text-sm text-muted-foreground'>Loading available slots...</p>
    );
  }

  if (slots.length === 0) {
    return (
      <p className='rounded-md border p-3 text-sm text-muted-foreground'>
        No available slots for this date.
      </p>
    );
  }

  return (
    <div className='grid grid-cols-2 gap-2 md:grid-cols-3'>
      {slots.map((slot) => (
        <Button
          key={slot.startTime}
          type='button'
          variant={
            selectedSlot?.startTime === slot.startTime ? 'default' : 'outline'
          }
          onClick={() => onSelect(slot)}
        >
          {formatPrivateLessonSlotTime(slot, timezone)}
        </Button>
      ))}
    </div>
  );
};
